import { renderAlert } from "../../../CommonComponents/Alert/Alert";
import { isStringifiedArrayWithPropName, parseAndSortValues } from "../../../helpers/ExportHelper";
import xTablesStore from "../redux/xTablesStore";
import { ImplementCopyPasteForMdv } from "./MdvHelper";
import { findDefaultItem, generateListDataForRollupStatus, getParentDateAsRollUp, getParentStatusAsRollUp, handleDurationUpdate, predecessorCellValidation, processDuration,  updateMDVParentValueAsRollup, updateParentPredecessorDate, updateParentPredecessorValue, updateParentRollupDate, updateParentRollupStatus, updateParentStatus, updateParentValueAsRollUp, updatePredecessorAndSuccessorRows, updateRowWithPredecessorAndSuccessors } from "./helperFunctions";
import { addUndoRow, checkNodesForCircularDependency, convertRowsToObjectWithIdAsKey, deepCopy, findColumnUsingParamsOrGridRef, getAllParentsOfANode, handleUndoRowUpdates, isValidPerson, parentRowsAferRollup, processParentNodes, processSuccessorNodes, removeEleFromStringWithCommaAsDelimiter, updateOrCreateObject  } from "./helpersSubModule";
import { checkIfRollupEnabledInMDV, isTimeSeriesPresent, updateCellValue, updateTotalIfValueIsChanged } from "./xTablesHelper";

export const handlePasteOrDeleteByType = (params, row, gridRef, newValue, cellValueCallbackArray, props, col, colToEdit, rowData, undoData,loggedInUser) => {
    const focusedCell = gridRef.current.api.getFocusedCell();
    switch (params.colDef.type) {
        case 'multi dimensional value':
             handleMultiDimensionalPaste(params, row, gridRef, newValue, focusedCell,loggedInUser);
            break;
        case 'person':
        case 'Assignee':
            handlePersonOrAssigneePasteOrDelete(params, row, newValue,loggedInUser);
            break;
        case 'duration':
            handleDurationPasteOrDelete(params, row, newValue,props,col,colToEdit, cellValueCallbackArray, gridRef,undoData,loggedInUser)
            break;
        case 'date':
            handleDatePasteOrDelete(params, newValue, row, gridRef, cellValueCallbackArray, rowData, undoData,loggedInUser);
            break;
        case 'predecessor':
            // handlePredecessorPasteOrDelete(params, row, newValue, cellValueCallbackArray, gridRef);
            break;
            case "shareableRollupList":
                handleStatusPasteOrDelete(params, row, newValue,loggedInUser);
                break;
            
        default:
            handleDefaultPasteOrDelete(params, row, newValue,loggedInUser);
    }
    return row;
}

// Function to handle multi-dimensional value paste
export const handleMultiDimensionalPaste = (params, row, gridRef, newValue, focusedCell,loggedInUser) => {
    renderAlert("Please note that data will only be pasted if the source and destination fields have the same properties.", "info", "", "", "Copy Paste For Multi Dimensiona Value Column Type");
    const mdvValue = newValue?ImplementCopyPasteForMdv(newValue, params.colDef.listData):"";
    if(mdvValue !=="[]"){
    row[params.colDef.field + "_es"] = updateCellValue(row, params.colDef.field + "_es", "value", mdvValue, loggedInUser)}
    row[params.colDef.field] = mdvValue;
    // row[params.colDef.field + "_es"].value = mdvValue;
    // if(params.colDef.block === 'timeseries') {
    //     let {rowUpdatedWithTotal,totalColumn} = updateTotalIfValueIsChanged('','',params,row,params.column)
    //     return rowUpdatedWithTotal
    // }

}
const handleDurationAndSuccessorNodeUpdate = (params, newValue, props, gridRef, row, col, colToEdit, undoData,loggedInUser) => {
    // Update row duration
    let updatedRows, undoRows
    let predeccessorColumn = findColumnUsingParamsOrGridRef(gridRef.current, 'predecessor')
    if(predeccessorColumn?.linkedColumns?.predecessorEndDate)
   {
     let endDateCol = findColumnUsingParamsOrGridRef(gridRef.current, 'date', predeccessorColumn.linkedColumns.predecessorEndDate)
   
    if (undoData[endDateCol.field] !== row[endDateCol.field]) {
        let { predecessorStartDate, predecessorEndDate, predecessor, duration, endDate, startDate } = endDateCol.linkedColumns || {};
        let isDurationColumnEdit = true
        let result = processSuccessorNodes(
            row[endDateCol.field],
            row,
            params.colDef,
            updatedRows,
            gridRef,
            predecessorStartDate,
            endDateCol.field,
            predecessor,
            duration,
            endDateCol.field,
            startDate,
            '',
            isDurationColumnEdit
        );
        // Merge results into parentRowsToUpdate and rowsForUndo only if they exist
        if (result?.changedSuccessorRows?.length > 0) {
            updatedRows = [...result.changedSuccessorRows]; // Flatten array
        }
        if (result?.undoRows?.length > 0) {
            undoRows = [...result.undoRows]; // Flatten array
        }
    }}
    return { updatedRows, undoRows };
};
export const handleDurationEdit = (params, newValue, props, gridRef, row, col, colToEdit, undoData, setUndoStack,loggedInUser) => {
    // Update the row duration
    let undatedrow = handleDurationUpdate(params, newValue, props, gridRef, row, col, colToEdit,loggedInUser);
    row=undatedrow
    let { updatedRows, undoRows } = handleDurationAndSuccessorNodeUpdate(
        params,
        newValue,
        props,
        gridRef,
        row,
        col,
        colToEdit,
        undoData
    );
     updatedRows = updatedRows?.length?[...updatedRows, row]:[row]; // Flatten array
    // Handle rollup changes
    let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup(updatedRows, gridRef, '', '');
    // Apply transaction to update rows in the grid
    gridRef.current.api.applyTransaction({
        update: mergedRowsAfterRollupAndPredecessorChange,
    });
    // Prepare undo rows
    undoRows = undoRows?.length?[...undoRows, undoData]:[undoData]; // Flatten array];
    handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, undoRows, 'id');
    // Push to undo stack
    setUndoStack([{
        type: 'row',
        action: 'transaction',
        index: params.node.rowIndex,
        previousRows: undoRows,
        cellRows: mergedRowsAfterRollupAndPredecessorChange,
        dontSelectCell: true,
    }]);
};

export const handleDurationPasteOrDelete = (params, row, newValue, props, col, colToEdit, cellValueCallbackArray, gridRef, undoData,loggedInUser) => {
    let undatedrow = handleDurationUpdate(params, newValue, props, gridRef, row, col, colToEdit,loggedInUser);
    row=undatedrow
    let { updatedRows, undoRows } = handleDurationAndSuccessorNodeUpdate(
        params,
        newValue,
        props,
        gridRef,
        row,
        col,
        colToEdit,
        undoData,
        loggedInUser
    );
    undoRows?.forEach(item => {
        // Find the corresponding row in parentRowsToUpdate using the unique id
        const correspondingRow = updatedRows?.find(row => row.id === item.id);
        if (correspondingRow) {
            cellValueCallbackArray.current.calls.push({
                row: correspondingRow, // Use the matched row
                undoRow: {
                    id: item.id,
                    column: params.colDef, // This should remain consistent for startDate or endDate changes
                    value: item[params.colDef.field] || "",
                    rowData: item,
                    index: parseInt(item['#']) - 1 // Adjust index as needed
                }
            });
        }
    });
}

// Function to handle person or assignee column paste and delete
export const handlePersonOrAssigneePasteOrDelete = (params, row, newValue,loggedInUser) => {
    newValue = newValue && isValidPerson(newValue) ? newValue :"" ;
    let oldRowData = {
        ...row,
        [params.colDef.field + "_es"]: {
          ...row[params.colDef.field + "_es"],
          value: params.oldValue
        }
      };
    row[params.colDef.field + "_es"] = updateCellValue(row, params.colDef.field + "_es", "value", newValue, loggedInUser)
    row[params.colDef.field] = newValue
    // row[params.colDef.field + "_es"].value = newValue;
}


// Function to handle date column paste
export const handleDatePaste = (params, newValue, row, gridRef, cellValueCallbackArray, changedSuccessorRows, successorUndoRows,loggedInUser) => {
    let { duration, endDate, startDate, predecessor, predecessorStartDate, predecessorEndDate } = params.colDef.linkedColumns || {};
    let data;
    // Explicitly set type to any[]
    if (startDate) {
        data = processDuration(row, duration, startDate, params?.colDef.field, params?.colDef,params.oldValue,'','',loggedInUser );
        const result = processSuccessorNodes(newValue, row, params.colDef, [data], gridRef, predecessorStartDate, predecessorEndDate, predecessor, duration, endDate, startDate);
        // Ensure result is an object with properties
        // Update the original arrays (passed by reference)
        if (result?.changedSuccessorRows?.length) {
            changedSuccessorRows.push(...result.changedSuccessorRows);
        }
        if (result?.undoRows?.length) {
            successorUndoRows.push(...result.undoRows);
        }
    }
    else {
        data = processDuration(row, duration, params?.colDef.field, endDate, params?.colDef,params.oldValue,'','',loggedInUser);
        if (newValue && newValue !== '' && data[endDate] && data[endDate] !== '') {
            const result = processSuccessorNodes(data[endDate], row, params.colDef, [data], gridRef, predecessorStartDate, predecessorEndDate, predecessor, duration, endDate, startDate);
            // Ensure result is an object with properties
            // Update the original arrays (passed by reference)
            if (result?.changedSuccessorRows?.length) {
                changedSuccessorRows.push(...result.changedSuccessorRows);
            }
            if (result?.undoRows?.length) {
                successorUndoRows.push(...result.undoRows);
            }
        }
    }
    row = data;
    //  rowsToUpdate.push(row);
}

// Function to handle date column delete
export const handleDateDelete = (params, newValue, row, gridRef, cellValueCallbackArray, changedSuccessorRows, successorUndoRows,loggedInUser) => {
    // on deleteing the date only the duration part get deleted( if( you need to delete the predecessor also then need to update predecessor row sucessornodes))
    row[params.colDef.field + "_es"] = updateCellValue(row, params.colDef.field + "_es", "value", '', loggedInUser)
    row[params.colDef.field] = ''
    // row[params.colDef.field + '_es'].value = ''
    if (params.colDef.linkedColumns) {
        row[params.colDef.linkedColumns.duration] = '';
        if(row[params.colDef.linkedColumns.duration] && row[params.colDef.linkedColumns.duration + '_es'].value)
        row[params.colDef.linkedColumns.duration + '_es'] = updateCellValue(row, params.colDef.linkedColumns.duration + '_es', "value", '', loggedInUser)
        // row[params.colDef.linkedColumns.duration + '_es'].value = '';
    }
    let { duration, endDate, startDate, predecessor, predecessorStartDate, predecessorEndDate } = params.colDef.linkedColumns || {};

    // Process successor nodes to determine updates
    const result = processSuccessorNodes(
        newValue,
        row,
        params.colDef,
        row,
        gridRef,
        predecessorStartDate,
        predecessorEndDate,
        predecessor,
        duration,
        endDate,
        startDate,
    ) || {};

    // Update the original arrays (passed by reference)
    if (result?.changedSuccessorRows?.length) {
        changedSuccessorRows.push(...result.changedSuccessorRows);
    }
    if (result?.undoRows?.length) {
        successorUndoRows.push(...result.undoRows);
    }
}

// Function to handle date column paste and delete
export function handleDatePasteOrDelete(params, newValue, row, gridRef, cellValueCallbackArray, rowData, undoData,loggedInUser) {
    let changedSuccessorRows = [];  // Explicitly set type to any[]
    let successorUndoRows = [];
    if (params.source === 'paste' || (params.source === 'rangeService' && (newValue && newValue != ''))) {
        handleDatePaste(params, newValue, row, gridRef, cellValueCallbackArray, changedSuccessorRows, successorUndoRows,loggedInUser)
    }
    else {
        handleDateDelete(params, newValue, row, gridRef, cellValueCallbackArray, changedSuccessorRows, successorUndoRows,loggedInUser)
    }
    let updatedRows = [row, ...changedSuccessorRows], undoRows = [undoData, ...successorUndoRows]
    undoRows.forEach(item => {
        // Find the corresponding row in parentRowsToUpdate using the unique id
        const correspondingRow = updatedRows?.find(row => row.id === item.id);
        if (correspondingRow) {
            cellValueCallbackArray.current.calls.push({
                row: correspondingRow, // Use the matched row
                undoRow: {
                    id: item.id,
                    column: params.colDef, // This should remain consistent for startDate or endDate changes
                    value: item[params.colDef.field] || "",
                    rowData: item,
                    index: parseInt(item['#']) - 1 // Adjust index as needed
                }
            });
        }
    });
}

// Function to handle predecessor column paste
export function handlePredecessorPaste(params, row, gridRef, newValue) {
    row[params.colDef.field] = newValue;
    row[params.colDef.field + "_es"].value = newValue;
}

// Function to handle predecessor column  delete
export function handlePredecessorDelete(params, row, cellValueCallbackArray, gridRef) {

    let successorIds = row['predecessorNodes']?.split(',').filter(Boolean);
    let updateSuccessorRows = []
    let SuccessorRowsUndoRows = []
    successorIds?.forEach(id => {
        let successorRowNode = params.api.getRowNode(id);
        if (successorRowNode && successorRowNode.data) {
            let successorRowData = successorRowNode.data;
            if (SuccessorRowsUndoRows.length === 0) {
                SuccessorRowsUndoRows.push(JSON.parse(JSON.stringify(successorRowData)));
            }
            else {
                SuccessorRowsUndoRows.push(JSON.parse(JSON.stringify(successorRowData)));
            }
            successorRowData['successorNodes'] = removeEleFromStringWithCommaAsDelimiter(successorRowData['successorNodes'], row.id)
            updateSuccessorRows.push(successorRowData);
        }
    })
    // Add undo entries for modified successor rows
    SuccessorRowsUndoRows?.forEach((item, index) => {
        addUndoRow(updateSuccessorRows[index], 'successorNodes', params.colDef, item.successorNodes, parseInt(item['#']) - 1, item, cellValueCallbackArray);
    });
    row['predecessorNodes'] = '';
    // // Add undo entry for the original row we are handleing this in original function
    // addUndoRow(row, '', params.colDef, params.oldValue || "", parseInt(row['#']) - 1, row, cellValueCallbackArray);
}

// Function to handle predecessor column paste and delete
export function handlePredecessorPasteOrDelete(params, row, newValue, cellValueCallbackArray, gridRef) {
    if (params.source === 'paste') {
        // handlePredecessorPaste(params, row, gridRef,newValue)
    }
    else {
        handlePredecessorDelete(params, row, cellValueCallbackArray, gridRef)
    }
}
export function containsRowId(value) {
    if (!value) return false; // Handle null, undefined, or empty cases

    try {
        if (typeof value === 'string' && value?.startsWith('{') ) {
            const parsedValue = JSON.parse(value);
            return parsedValue && typeof parsedValue === "object" && "rowId" in parsedValue;
        }
        else return false
    } catch (error) {
        console.error("Error parsing value:", value, error);
        // If parsing fails, return false
        return false;
    }
}
// Function to handle other column paste and delete
export function handleDefaultPasteOrDelete(params, row, newValue,loggedInUser) {
     if (newValue && isStringifiedArrayWithPropName(newValue)) {
        newValue = parseAndSortValues(newValue);
    } else if (newValue && containsRowId(newValue)) {
        newValue = JSON.parse(newValue).value;
    }else if (typeof newValue === 'string' && newValue.startsWith('{')) {
        try {
            const parsedValue = JSON.parse(newValue);
            if (parsedValue && typeof parsedValue === 'object' && parsedValue.value) {
                newValue = parsedValue.value;
            }
        } catch (error) {
            console.error("Invalid JSON format in handleDefaultPasteOrDelete:", newValue, error);
            newValue=''
          
        }
    } 
    let oldRowData = {
        ...row,
        [params.colDef.field + "_es"]: {
          ...row[params.colDef.field + "_es"],
          value: params.oldValue
        }
      };
    row[params.colDef.field + '_es'] = updateCellValue(row, params.colDef.field + '_es', "value", newValue, loggedInUser)
    row[params.colDef.field] = newValue;
}
export function getMatchedValueObject(listData, val, oldValue) {
    if (!val) return ''
    const matchedItem = listData.find(item => item.value.toLowerCase() === val.toLowerCase());
    if (matchedItem) {
        if (matchedItem?.rowId) {
            if (matchedItem?.rowId !== 'None')
                return JSON.stringify({ rowId: matchedItem.rowId, value: matchedItem.value });
            else '';
        } else {
            return matchedItem.value;
        }
    } else {
        return oldValue;
    }
}
export function parseNewValue(val) {
    try {
        return JSON.parse(val);
    } catch {
        return null;
    }
}
export function isParsedValueValid(parsed) {
    return parsed && typeof parsed === 'object' && parsed.value &&
           !(parsed.parentMaxPrecedence && parsed.parentMinPrecedence);
}
// function getMatchedValueObject(listData, input) {
//     if (!input) return null;

//     const normalizedInput = input.trim().toLowerCase();
//     return listData.find(item => item.value.toLowerCase() === normalizedInput) || null;
// }
export function handleStatusPasteOrDelete(params, row, newValue, loggedInUser) {
    let columnListData = JSON.parse(params.colDef.listData)
    // Remove existing default status entry if it exists
    columnListData = columnListData.filter(
        item => !(item.parent === 'Default Status' && item.rowId === 'None')
    );

    let defaultState=params.colDef.defaultStatus ? JSON.parse(params.colDef.defaultStatus) : {
        value: 'Backlog',
        parent: 'Default Status',
        precedence: '0:0',
        rowId: 'None',
    }
    columnListData.push(defaultState)
    // }
    let { listData, precedenceMapping } = generateListDataForRollupStatus(columnListData);
    let valueObj
    const parsedValue = typeof newValue === 'string' && newValue.startsWith('{') ? parseNewValue(newValue) : null;
    if (newValue && containsRowId(newValue)) {
        let parsed = parseNewValue(newValue);
        if(parsed?.rowId==='None'){
            valueObj = JSON.stringify({rowId:'None', value:defaultState.value})
        }
       else if (parsed?.value) {
            valueObj = getMatchedValueObject(listData, parsed.value,params.oldValue);
        }
    }
    else if (parsedValue && isParsedValueValid(parsedValue)) {
        valueObj = getMatchedValueObject(listData, parsedValue.value,params.oldValue);
    }
     else {
        valueObj = getMatchedValueObject(listData, newValue,params.oldValue);
    }
    if (params.source === "paste") {
        if (typeof valueObj === "string" && valueObj.startsWith('{') && JSON.parse(valueObj).rowId === 'None') {
            if (!row['primaryCol']) {
                valueObj = params?.oldValue ?params?.oldValue :'';
            }
        }
    }
        row[params.colDef.field + '_es'] = updateCellValue(row, params.colDef.field + '_es', "value", valueObj, loggedInUser);
        row[params.colDef.field] = valueObj;
}

// Helper function to handle validation and processing
function processNewValue(isValidOption, newValue, params, row, loggedInUser) {
    if (!isValidOption && newValue !== "") {
        renderAlert("Copied content does not match with options", "error");
        row[params.colDef.field] = params.oldValue;
        return;
    }

    newValue = newValue && isStringifiedArrayWithPropName(newValue) ? parseAndSortValues(newValue) : newValue;
    row[params.colDef.field] = newValue;
    row[params.colDef.field + '_es'] = updateCellValue(row, params.colDef.field + '_es', "value", newValue, loggedInUser);
}
export function handleDropDownList(params, row, newValue, loggedInUser) {
    let isValidOption = true;
    if (params.colDef.type === 'shareableRollupList') {
        // Parse newValue if it's a stringified object, otherwise use as-is
        let formattedValue;
        if (containsRowId(newValue)) {
            formattedValue = JSON.parse(newValue).value;
        } else if (typeof newValue === "string" && newValue.startsWith("{")) {
            formattedValue = JSON.parse(newValue).value;
        } else {
            formattedValue = newValue;
        }

        let matchedItem = JSON.parse(params.colDef.listData).find(item =>
            item.value.toLowerCase() === formattedValue.toLowerCase() ? item : false
        );
        isValidOption = matchedItem;
        if (matchedItem) {
            newValue = JSON.stringify({ rowId: matchedItem.rowId, value: matchedItem.value });
        }
    }
    else {
        isValidOption = params.colDef.listData.some(item => item.toLowerCase() === newValue.toLowerCase());
    }
    processNewValue(isValidOption, newValue, params, row, loggedInUser);  
}
const handleDateColumnRollupUpdate = (params, rowData, colToEdit, newValue, dateColumn,loggedInUser) => {
    return updateParentRollupDate(
        rowData[params.node.rowIndex].parent,
        colToEdit,
        dateColumn.field,
        [],
        newValue,
        params.node.rowIndex,
        params.colDef.rollup,
        loggedInUser
    );
};
export function processDateRollupsAndSuccessorNodes(parentNode, parentNodeData, dateRollupColumns, updatedChildRowData, gridRef, predecessorStartDate, predecessorEndDate, predecessor, duration, endDate, startDate, endDateColumn, endDateBeforeProcessing, additionalRowsForUndo, { totalColumn, timeSeriesColumn },sortedParentNodes,loggedInUser) {
    let columnTypeObj = {}
    dateRollupColumns.forEach((colDef, index) => {
        if(colDef.type==='shareableRollupList'&& !colDef.azureColumn ){
            getParentStatusAsRollUp(parentNode, parentNodeData, colDef.field, colDef?.rollup, updatedChildRowData, colDef,loggedInUser);
        }
        // For each column, run the rollup logic, passing the updated data from the previous column
      else { getParentDateAsRollUp(parentNode, parentNodeData, colDef.field, colDef?.rollup, updatedChildRowData, colDef,loggedInUser);}
        if (colDef.block) columnTypeObj[colDef.block] = colDef
        else columnTypeObj[colDef.type] = colDef
    });
    //post processing for row  (timeseries total)
    if (columnTypeObj['timeseries']) {
        updateTotalIfValueIsChanged(timeSeriesColumn, totalColumn, {colDef: columnTypeObj['timeseries']}, parentNodeData)
    }
    let endDateAfterProcessing = parentNodeData[endDateColumn.field]
    if (parentNodeData.successorNodes && endDateAfterProcessing != endDateBeforeProcessing) {
        let result = processSuccessorNodes(endDateAfterProcessing, parentNodeData, endDateColumn, [parentNodeData], gridRef, predecessorStartDate, predecessorEndDate, predecessor, duration, endDate, startDate);
        // Merge results into parentRowsToUpdate and rowsForUndo
        let successorParentNodes = new Set();
        if (result?.changedSuccessorRows?.length > 0) {
            result.changedSuccessorRows.forEach((row) => {
                updatedChildRowData[row.id] = row; // Add undo row to additionalRowsForUndo
                // Check if the changed successor row has parents and process rollups recursively

                let node = gridRef.current.api.getRowNode(row.id);
                let parents = getAllParentsOfANode(node);
                parents.forEach((parentNode) => {
                 //   if (!sortedParentNodes.includes(parentNode)) {
                    successorParentNodes.add(parentNode)
                //}
            });
            });
        }
        if (result?.undoRows?.length > 0) {
            result.undoRows.forEach((row) => {
                if (!additionalRowsForUndo[row.id]) {
                    additionalRowsForUndo[row.id] = row; // Add undo row to additionalRowsForUndo
                }
            });
        }
        // update the parent nodes of successors nodes
        if (successorParentNodes && successorParentNodes.size > 0) {
            const sortedsuccessorParentNodes = Array.from(successorParentNodes).sort((a, b) => b.rowIndex - a.rowIndex);
            processParentNodes(
               sortedsuccessorParentNodes,
                updatedChildRowData,
                additionalRowsForUndo,
                dateRollupColumns,
                gridRef,
                predecessorStartDate,
                predecessorEndDate,
                predecessor,
                duration,
                endDate,
                startDate,
                endDateColumn,
                totalColumn,
                timeSeriesColumn,
                sortedParentNodes
            );
        }
    }
}
export const getTotalColumn = (params)=>{
    let columns = params.api.getColumnDefs()
    const isTimeSeriesPresentInColumns = isTimeSeriesPresent(columns);

    if (isTimeSeriesPresentInColumns === -1) return columns;
 
    let timeSeriesColumn = columns[isTimeSeriesPresentInColumns]

    let totalColumn = timeSeriesColumn.children?.find(
        (child) => child.headerName === 'Total'
      );
     return {totalColumn,timeSeriesColumn: timeSeriesColumn}
}
function processDateColumn(rowData, params, colToEdit, newValue, parentNodes, gridRef, updatedRows, undoRows, row, undoData,loggedInUser) {
    // Handle date column updates with rollup or predecessor logic
    if (params.colDef.rollup) {
        if (!params.colDef.linkedColumns) {
            let undoRowsIncludingParent = [undoData], updatedRowsIncludingParent = [row]
            // Handle the update for the first column directly
            let allUpdatedParentRowsData = handleDateColumnRollupUpdate(params, rowData, colToEdit, newValue, params.colDef,loggedInUser);
            updatedRowsIncludingParent = [...updatedRowsIncludingParent, ...allUpdatedParentRowsData]
            return {mergedRowsAfterRollupAndPredecessorChange: updatedRowsIncludingParent, undoRows : undoRowsIncludingParent }
        }
        else {
            let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup(updatedRows, gridRef, '', '','');
            // Prepare undo rows
            if (undoRows)
                handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, undoRows, 'id');
            else {
                undoRows = additionalParentAndExtraRowsForUndo
            }
            return { mergedRowsAfterRollupAndPredecessorChange, undoRows }
        }
    }
    else {
        return updateParentPredecessorDate(
            rowData[params.node.rowIndex].parent,
            colToEdit,
            params.colDef.field,
            [],
            params.newValue,
            params.node.rowIndex
        );
    }
}

function processNumberColumn(rowData, params, colToEdit,loggedInUser) {
    if (params.colDef.rollup) {
        return updateParentValueAsRollUp(
            rowData[params.node.rowIndex].parent,
            colToEdit,
            params.colDef.field,
            [],
            params.newValue,
            params.node.rowIndex,
            params.colDef.rollup,
            loggedInUser
        )
    } else {
        return updateParentPredecessorValue(
            rowData[params.node.rowIndex].parent,
            colToEdit,
            params.colDef.field,
            [],
            params.newValue,
            params.node.rowIndex,
            loggedInUser
        );
    }
}
function processStatusColumn(rowData, params, gridRef, valueChangedByValueGetter, colToEdit, newValue,loggedInUser) {
    return updateParentStatus(
        rowData[params.node.rowIndex].parent,
        colToEdit,
        params.colDef.field,
        [],
        newValue,
        params.node.rowIndex,
        gridRef,
        valueChangedByValueGetter,
        loggedInUser
    );
}

function processOtherColumn(
    rowData,
    params,
    precedenceMapping,
    listData,
    valueChangedByValueGetter,
    colToEdit,
    newValue,
    loggedInUser
) {
    return updateParentRollupStatus(
        rowData[params.node.rowIndex].parent,
        colToEdit,
        params.colDef.field,
        [],
        newValue,
        params.node.rowIndex,
        precedenceMapping,
        listData,
        params,
        valueChangedByValueGetter,
        loggedInUser || props.user
    );
}

function processMDVColumn (rowData, params, colToEdit,loggedInUser, newValue, listData) {
    try {
        if(checkIfRollupEnabledInMDV(JSON.parse(newValue))){
            console.log("inside rollup");
            return updateMDVParentValueAsRollup(
                rowData[params.node.rowIndex].parent,
                colToEdit,
                params.colDef.field,
                [],
                newValue,
                params.node.rowIndex,
                loggedInUser,
                listData
            )
            
        }
    } catch (error) {
        console.error("Error in processMDVColumn",error);
    }
}

export function processParentRows(
    params,
    rowData,
    gridRef,
    valueChangedByValueGetter,
    precedenceMapping,
    listData,
    colToEdit,
    newValue,
    row,
    undoData,
    updatedRows,
    extraUndoRows,
    loggedInUser
) {
    // Get ancestors of the current node for undo operations
    let parentNodes = getAllParentsOfANode(params.node)
    let rowsForUndo = []
    parentNodes.forEach((node) => {
        // Deep copy the node and modify it if needed
        let modifiedNode = JSON.parse(JSON.stringify(node.data));
        // Push the modified node to rowsForUndo
        rowsForUndo.push(modifiedNode);
    });
   
    let parentRowsToUpdate = [];

    switch (params.colDef.type) {
        case 'date':
            let { mergedRowsAfterRollupAndPredecessorChange, undoRows } = processDateColumn(rowData, params, colToEdit, newValue, parentNodes, gridRef, updatedRows, extraUndoRows, row, undoData,loggedInUser)
            if (mergedRowsAfterRollupAndPredecessorChange?.length)
                parentRowsToUpdate = [...parentRowsToUpdate, ...mergedRowsAfterRollupAndPredecessorChange];
            if (undoRows?.length)
                rowsForUndo = rowsForUndo.concat(undoRows)
            break;
        case 'number':
            parentRowsToUpdate = processNumberColumn(rowData, params, colToEdit,loggedInUser);
            rowsForUndo.push(undoData);
            break;
        case 'multi dimensional value' :
            parentRowsToUpdate = processMDVColumn(rowData, params, colToEdit,loggedInUser, newValue, listData);
            rowsForUndo.push(undoData);
            break;
        case 'status':
            if (!params?.colDef?.azureColumn) {
                parentRowsToUpdate = processStatusColumn(rowData, params, gridRef, valueChangedByValueGetter, colToEdit, newValue, loggedInUser);
                rowsForUndo.push(undoData);
            }

            break;
        default:
            if (!params?.colDef?.azureColumn) {
                parentRowsToUpdate = processOtherColumn(rowData, params, precedenceMapping, listData, valueChangedByValueGetter, colToEdit, newValue, loggedInUser);
                rowsForUndo.push(undoData);
            }

            break;
    }
    if (params.colDef.type !== 'date') {
        if (parentRowsToUpdate.length > 0) {
            parentRowsToUpdate.push(row);
        } else {
            parentRowsToUpdate = [row];
        }
    }
    return { rowsForUndo, parentRowsToUpdate };
}

export const findRowDataForUndo = (rowsForUndo, rowId) => {
    return rowsForUndo.find(row => row.id === rowId);
};

export function processRowForDateColumn(params, row, updatedRows, undoRows, gridRef, newValue, undoData) {
    let result
    let { duration, endDate, startDate, predecessor, predecessorStartDate, predecessorEndDate } = params.colDef.linkedColumns
    let startDateCol = startDate ? startDate : params.colDef.field
    let endDateCol = startDate ? params.colDef.field : endDate
    const predecessorData = params.api.getRowNode(params.data["predecessorNodes"])?.data
    processDuration(row, duration, startDateCol, endDateCol, params?.colDef,params.oldValue, predecessorData)
    if (undoData[endDateCol] !== row[endDateCol]) {
        result = processSuccessorNodes(newValue, row, params.colDef, updatedRows, gridRef, predecessorStartDate, predecessorEndDate, predecessor, duration, endDate, startDate);
        // Merge results into parentRowsToUpdate and rowsForUndo only if they exist
        if (result?.changedSuccessorRows?.length > 0) {
            updatedRows = [...result.changedSuccessorRows]; // Flatten array
        }
        if (result?.undoRows?.length > 0) {
            undoRows = [...result.undoRows]; // Flatten array
        }
    }
    if (updatedRows?.length) {
        updatedRows.push(row);
    }
    else {
        updatedRows = [row]
    }
    if (undoRows?.length) {
        let undoDataArray = [undoData]
        undoRows = [...undoRows, ...undoDataArray]
    }
    else {
        undoRows = [undoData]
    }
    return { updatedRows, undoRows }
}

export function processPredecessorColumnCellValueEdit(params, row, newValue, undoData, setUndoStack, gridRef, rowData) {
    let rowNode = params.node;
    // Handle the case where the new value is null, undefined, or empty
    if (newValue === null || newValue === undefined || newValue === '') {
        let { predecessorRows, currentRow, rowsForUndo } = updatePredecessorAndSuccessorRows(params.column, row, params, newValue, params.oldValue)
        let rowsToUpdate = [currentRow]
        let undoRowAfterDeletingDate = [undoData]
        if (predecessorRows) rowsToUpdate = rowsToUpdate.concat(predecessorRows)
        if (rowsForUndo != undefined)
            undoRowAfterDeletingDate = undoRowAfterDeletingDate.concat(rowsForUndo);
        let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup(rowsToUpdate, gridRef, '', '')
        handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, undoRowAfterDeletingDate, 'id');
        setUndoStack([{ type: 'row', action: 'transaction', index: params.node.rowIndex, previousRows: undoRowAfterDeletingDate, cellRows: mergedRowsAfterRollupAndPredecessorChange, dontSelectCell: true }])
        params.api.applyTransactionAsync({
            update: mergedRowsAfterRollupAndPredecessorChange,
        })
        let {highlight} = xTablesStore.getState().gridReducer
        if(highlight){
            setTimeout(() => {
               gridRef.current.api.redrawRows();
            }, 0)}
    }
    // Return if the row ID is not part of a hierarchical structure
    if (!rowNode.data.l_id.split('.').length > 1) return
    else {
        let { predecessorEndDate: endDate, predecessorStartDate: startDate } = params.colDef.linkedColumns
        let { formattedDate, validatedPredecessorValue, updatedRow } = predecessorCellValidation(params, row, newValue, rowData, startDate, endDate, gridRef)
        updateRowWithPredecessorAndSuccessors(params, validatedPredecessorValue, formattedDate, updatedRow, startDate, endDate, gridRef, undoData, setUndoStack)
    }
}

export const populateBacklogStatusColumnIfNeeded = (row, colToEdit,skipPrimaryColumnValidation,statusColumn,loggedInUser) => {
    const statusColumns = statusColumn || xTablesStore.getState().gridReducer.statusColumns;

    Object.entries(statusColumns).forEach(([colId, colDef]) => {
        if (colDef?.listData) {
            try {
                let backlogItem = colDef?.defaultStatus ?JSON.parse(colDef?.defaultStatus):{
                    value: 'Backlog',
                    parent: 'Default Status',
                    precedence: '0:0',
                    rowId: 'None',
                }
               let listData=JSON.parse(colDef?.listData)
                let defaultItem= findDefaultItem(listData, backlogItem)
                if(defaultItem){
                backlogItem=defaultItem
                }
                if (backlogItem && ((row[colToEdit]?.value && row[colToEdit]?.value.trim() !== '')||skipPrimaryColumnValidation)) {
                    const value = JSON.stringify({ rowId: backlogItem?.rowId||'', value: backlogItem.value });

                    if (!row[colDef?.field]) {
                        row[colDef.field] = value;
                    }
                    if (!row[colDef.field + '_es'] || !row[colDef.field + '_es'].value) {
                        row[colDef.field + '_es'] =  updateCellValue(row,colDef.field,"value",value,loggedInUser)
                    }
                }
            }
            catch (e) {
                console.error(`Failed to parse listData for column ${colId}:`, e);
            }
        }
    });
};

export const handlePrimaryColumnEdit = (
    row,
    params,
    previousRowData,
    nextRowData,
    rowData,
    currentRowData,
    gridRef,
    undoData,
    setUndoStack,
    setRedoStack,
    CheckinAgentRow,
    colToEdit,
    previousContentOfRow
) => {
   let isAzureRow = params?.node?.data?.isAzureRow
    populateBacklogStatusColumnIfNeeded(row, colToEdit);
    if (!CheckinAgentRow && !isAzureRow && colToEdit === "primaryCol_es" && params.source !== 'paste' && !previousContentOfRow && previousRowData?.l_id?.includes('.') && !nextRowData?.l_id?.includes(row.id)) {
        let parentl_idlength = rowData[params?.node?.rowIndex - 1] ? previousRowData.l_id.split('.').length : -1
        let l_idLength = currentRowData.l_id.split('.').length
        if (parentl_idlength > l_idLength) {
            let checkOutParent = previousRowData.l_id.split('.').slice(0, -1).join('.')
            if (!(params.value === null && params.oldValue !== undefined))
                if (checkOutParent) row.l_id = checkOutParent + "." + row.id
                setTimeout(() => {
                    let undoRows = [undoData]
                    gridRef.current.api.refreshCells({ rowNodes: [row], force: true })
                    let { rowsRefinedWithPredecessorChanges, allRowsIncludingRefinedOnes, arrayOfAdditionalUndoRows } = checkNodesForCircularDependency([params.node], gridRef)
                    if (arrayOfAdditionalUndoRows?.length) {
                        handleUndoRowUpdates(arrayOfAdditionalUndoRows, undoRows, 'id');
                    }
                    let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup([row], gridRef, '', '')
                    gridRef.current.api.applyTransactionAsync({
                        update: mergedRowsAfterRollupAndPredecessorChange
                    })
            
                    handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, undoRows, 'id');
                    setUndoStack([{ type: 'row', action: 'transaction', index: params.node.rowIndex, previousRows: undoRows, cellRows: mergedRowsAfterRollupAndPredecessorChange, dontSelectCell: true }])
                    setRedoStack([])
                }, 0)
        }
    }
    else if(!CheckinAgentRow && colToEdit === "primaryCol_es" && params.source !== 'paste' && params.source !== 'rangeService'&&params.source !== "clipboardService"){
        setTimeout(() => {
            let undoRows = [undoData]
            gridRef.current.api.refreshCells({ rowNodes: [row], force: true })
            let { rowsRefinedWithPredecessorChanges, allRowsIncludingRefinedOnes, arrayOfAdditionalUndoRows } = checkNodesForCircularDependency([params.node], gridRef)
            if (arrayOfAdditionalUndoRows?.length) {
                handleUndoRowUpdates(arrayOfAdditionalUndoRows, undoRows, 'id');
            }
            let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup([row], gridRef, '', '')
            gridRef.current.api.applyTransactionAsync({
                update: mergedRowsAfterRollupAndPredecessorChange
            })
    
            handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, undoRows, 'id');
            setUndoStack([{ type: 'row', action: 'transaction', index: params.node.rowIndex, previousRows: undoRows, cellRows: mergedRowsAfterRollupAndPredecessorChange, dontSelectCell: true }])
            setRedoStack([])
        }, 0)
    }
}


